/** Navigation feedback only. No cached home data, editor, requests or effects. */
export default function WorkspaceHomePreview({ onCancel }: { onCancel: () => void }) {
  return <main data-workspace-home-preview aria-busy="true"
    className="flow-font min-h-screen bg-[#F7F5F0] text-[#262521]"
    style={{ "--sidebar-w": "0px", "--topbar-h": "0px", "--flow-page-bg": "#F7F5F0" } as React.CSSProperties}>
    <div className="mx-auto w-full max-w-[960px] px-5 pb-12 pt-20 sm:px-8">
      <h1 className="text-[26px] font-semibold leading-[1.2]">Домашняя</h1>
      <p role="status" className="mt-[5px] text-[12.5px] text-[#9A968D]">Открываем разделы…</p>
      <div aria-hidden="true" className="mt-6 space-y-6">
        <div className="ui-skeleton h-11 w-full rounded-lg" />
        <div className="grid grid-cols-1 gap-x-7 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2, 3, 4, 5].map(index => <div key={index} className="flex h-[34px] items-center gap-2.5 border-b border-[#F0EEE8]">
            <span className="ui-skeleton h-5 w-5 rounded-[5px]" />
            <span className="ui-skeleton h-2.5 w-24 rounded" />
          </div>)}
        </div>
      </div>
      <button type="button" onClick={onCancel} className="mt-6 rounded text-xs text-[#8F8B82] underline underline-offset-2 hover:text-[#37352F] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">
        Отменить переход
      </button>
    </div>
  </main>;
}
